
export default function SupportResources() {
  const supportItems = [
    {
      icon: 'ri-book-open-line',
      title: '教材・カリキュラム提供',
      description: 'プロフェッショナルな教材とカリキュラムを無償提供。すぐに授業を始められます',
      color: 'from-rose-400 to-pink-500',
      image: 'https://public.readdy.ai/ai/img_res/b884308eef512e8e45f2049e7e847cac.jpg',
    },
    {
      icon: 'ri-presentation-line',
      title: '開講準備サポートレッスン',
      description: 'スクール・サロン開講に向けた実践的なレッスン。',
      color: 'from-purple-400 to-pink-500',
      image: 'https://readdy.ai/api/search-image?query=nail%20school%20opening%20preparation%20support%20session%20instructor%20teaching%20business%20setup%20strategies%20modern%20classroom%20setting%20practical%20training%20comprehensive%20guidance%20professional%20consultation%20atmosphere&width=600&height=400&seq=support002&orientation=landscape',
    },
    {
      icon: 'ri-team-line',
      title: 'コミュニティアクセス',
      description: '全国の認定講師とつながり、情報交換や相談ができる専用コミュニティ',
      color: 'from-pink-400 to-rose-500',
      image: 'https://readdy.ai/api/search-image?query=professional%20nail%20educators%20networking%20community%20meeting%20group%20of%20instructors%20collaborating%20sharing%20knowledge%20friendly%20atmosphere%20modern%20conference%20room%20teamwork%20and%20connection%20concept&width=600&height=400&seq=support003&orientation=landscape',
    },
    {
      icon: 'ri-refresh-line',
      title: '継続的なスキルアップ',
      description: '最新技術やトレンドを学べる定期的な研修・セミナーを開催',
      color: 'from-teal-400 to-cyan-500',
      image: 'https://readdy.ai/api/search-image?query=nail%20industry%20continuing%20education%20seminar%20workshop%20with%20latest%20techniques%20and%20trends%20professional%20development%20training%20modern%20venue%20instructors%20learning%20new%20skills%20inspiring%20educational%20atmosphere&width=600&height=400&seq=support004&orientation=landscape',
    },
  ];

  return (
    <section id="support" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-gray-900 mb-4">サポート&リソース</h2>
          <p className="text-sm md:text-lg text-gray-600">
            あなたの成功を支える充実のサポート体制
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {supportItems.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-3xl shadow-lg hover:shadow-xl transition-all overflow-hidden group cursor-pointer flex flex-col"
            >
              <div className="relative h-48 overflow-hidden">
                <img 
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className={`absolute top-6 left-6 w-16 h-16 bg-gradient-to-br ${item.color} rounded-2xl flex items-center justify-center shadow-lg`}>
                  <i className={`${item.icon} text-3xl text-white`}></i>
                </div>
              </div>

              <div className="p-8 text-center flex flex-col flex-grow">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">{item.title}</h3>
                <p className="text-gray-600 leading-relaxed flex-grow">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
